<template>
    <div>
        <title>券卡恢复使用</title>
        <article class="cardArticle">
            <section class="cardCon">
                <header class="tabHeader">
                    <p>
                        <router-link  :to="{path:'/CardsOut'}" v-if="openStoreDefinition==1">券卡定义激活</router-link>
                        <router-link  :to="{path:'/CardsActivation'}">券卡激活</router-link>
                        <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
                         <router-link  class="isActive" :to="{path:'/CardsReuse'}">券卡恢复</router-link>
                         <router-link :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
                         <router-link :to="{path:'/CardMdShop'}" v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
                    </p>
                </header>
                <main class="cardMain">
                    <!-- S 券卡验证表单 -->
                    <CodeCheck v-if="update" @verifytype ="verifyType" :operType="3" :codeType="codeType"></CodeCheck>
                    <!-- E 券卡验证表单 -->
                    <section>
                        <el-form :model="basicForm" v-model="labelPosition" label-width="100px">
                            <!-- S 基础设置 -->
                            <p class="commonTit"><b>基础设置</b></p>
                            <section class="basicSet">
                                <el-form-item label="备注">
                                    <el-input type="textarea" v-model="basicForm.memo" maxlength="100"></el-input>
                                </el-form-item>
                            </section>
                        </el-form>
                    </section>
                </main>
                <div class="bottomBtn">
                    <el-button type="primary" @click="suBmission" :loading="loadingshow">提交</el-button>
                    <el-button @click="reload">重置</el-button>
                </div>
            </section>
        </article>
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { Message, MessageBox } from "element-ui";
import { mapState, mapActions } from "vuex";
export default {
    name:'CardsRecover',
    components: {
        CodeCheck: resolve =>
            require(["@/components/CardsFolder/CodeCheck.vue"], resolve), //验证全码
    },
    data(){
        return {
            openStoreDefinition:0,
		       	loadingshow:false,
            update:true,
            codeType:'0',//券卡类型-礼品券卡
            labelPosition: "right", //labe文字右对齐,
            // 基础设置表单
            verifytype:0,
            basicForm: {
                memo:'',//备注
            },
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ============================================== 方法 ==============================================
    methods:{
        // 验证类型
    verifyType(type){
      this.verifytype = type
    },
    // 提交
    suBmission(){
	this.loadingshow = true;
      let param ={
        verifytype:this.verifytype,
        memo:this.basicForm.memo,
        opertype:3
      }
      Api.CODEINFOSUSPENDORRECOVER(param).then(res =>{
         if(res.data.status=="200"){
              this.reload();
              this.loadingshow = false;
              MessageBox.confirm(res.data.message, '提示', {
                confirmButtonText: '确定',
                showCancelButton:false,
                dangerouslyUseHTMLString: true,
                type: 'success'
              }).then(() => {}).catch(() => {});
            }else{
              if(res.data.status=="201"){
                this.reload();
              }
              this.loadingshow = false;
              MessageBox.confirm(res.data.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => {}).catch(() => {});
            }
      })
    },
    reload(){
        this.basicForm= {
            memo: "", //备注
        }
        // 移除组件
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
            this.update = true
        })
    }  
    },
    mounted() {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition')
    },
}
</script>
<style scoped>
.cardArticle{
    padding: 20px;
}
.cardMain >>> .el-input__inner {
  color: #666;
}
.cardCon {
  position: relative;
  padding: 84px 20px 85px 0;
  height: calc(100% - 169px);
}
@media (max-width: 1310px) {
  .cardCon header a {
    padding: 0 16px;
  }
}
.basicSet{
    padding:20px;
}
.basicSet .el-input,
.basicSet .el-textarea{
    width:300px;
}
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsReuse.vue